<div class="grid-section">
  <div *ngIf="isUserAgroModerator()" class="toolbar">
    <dx-button icon="plus" text="Dodaj novu firmu" type="default" (onClick)="onAddFirmaClick()">
    </dx-button>

    <dx-button icon="edit" text="Izmijeni firmu" type="default" [disabled]="!selectedFirma"
      (onClick)="onEditFirmaClick()">
    </dx-button>

    <dx-button icon="trash" text="Obriši firmu" type="danger" [disabled]="!selectedFirma"
      (onClick)="onDeleteFirmaClick()">
    </dx-button>

    <dx-button icon="like" text="Zainteresovanost firme" type="default" [disabled]="!selectedFirma"
      (onClick)="onSmsSortClick()">
    </dx-button>

    <dx-button icon="refresh" text="Osvježi" type="default" (onClick)="loadFirme(true)">
    </dx-button>
  </div>

  <dx-data-grid #firmeGrid id="firmeGrid" keyExpr="id" [dataSource]="gridData" [showBorders]="true"
    [allowColumnResizing]="true" [showColumnLines]="true" [showRowLines]="true" [hoverStateEnabled]="true"
    [filterRow]="{ visible: true }" [searchPanel]="{ visible: true }" [paging]="{ pageSize: 50 }" [pager]="{
      showPageSizeSelector: true,
      allowedPageSizes: [10, 20, 50, 100],
      showInfo: true
    }" [selection]="{ mode: 'single' }" [rowAlternationEnabled]="true" (onRowClick)="onFirmaRowClick($event)"
    [allowColumnReordering]="true" [columnAutoWidth]="false"
    [scrolling]="{ mode: 'standard', scrollByContent: true, showScrollbar: 'always' }">

    <dxi-column dataField="naziv" caption="Naziv" [minWidth]="200"></dxi-column>
    <dxi-column dataField="oblast" caption="Oblast" [minWidth]="150" [calculateCellValue]="getOblastName"></dxi-column>
    <dxi-column dataField="status" caption="Status" [minWidth]="150" [calculateCellValue]="getStatusName"></dxi-column>
    <dxi-column dataField="djelatnost" caption="Djelatnost" [minWidth]="150"
      [calculateCellValue]="getDjelatnostName"></dxi-column>
    <dxi-column dataField="grad" caption="Grad" [minWidth]="150" [calculateCellValue]="getGradName"></dxi-column>
    <dxi-column dataField="drzava" caption="Država" [minWidth]="150" [calculateCellValue]="getDrzavaName"></dxi-column>
    <dxi-column dataField="telefon1" caption="Telefon 1" [width]="120"></dxi-column>
    <dxi-column dataField="telefon2" caption="Telefon 2" [width]="120"></dxi-column>
    <dxi-column dataField="email" caption="Email" [minWidth]="150"></dxi-column>
    <dxi-column dataField="direktor" caption="Direktor" [minWidth]="150"></dxi-column>
    <dxi-column dataField="kontakt1" caption="Kontakt 1" [minWidth]="150"></dxi-column>
    <dxi-column dataField="kontakt2" caption="Kontakt 2" [minWidth]="150"></dxi-column>

    <dxo-scrolling mode="virtual"></dxo-scrolling>
    <dxo-sorting mode="multiple"></dxo-sorting>
  </dx-data-grid>
</div>

<!-- MERGED FIRMA & KOMENTARI POPUP -->
<dx-popup [width]="1200" [height]="700" [showTitle]="true"
  [title]="(isCreateFirma ? 'Dodaj Novu Firmu' : 'Izmijeni Firmu') + (selectedFirma ? ' - ' + selectedFirma.naziv : '')"
  [(visible)]="isFirmaPopupVisible" (onHiding)="onFirmaPopupHidden()">

  <div *dxTemplate="let data of 'content'">
    <div class="merged-popup-content">
      <!-- Left Side - Firma Form -->
      <div class="firma-section">
        <h3>Podaci o firmi</h3>
        <form [formGroup]="firmaForm">
          <div class="form-fields">
            <div class="form-row">
              <div class="full-width">
                Naziv *
                <dx-text-box formControlName="naziv" placeholder="Naziv firme *"
                  [isValid]="!firmaForm.get('naziv')?.errors" validationMessage="Naziv je obavezan">
                </dx-text-box>
              </div>
            </div>

            <div class="form-row">
              <div class="half-width">
                Oblast
                <dx-select-box formControlName="oblast" [dataSource]="oblasti" displayExpr="oblast" valueExpr="id"
                  placeholder="Odaberite oblast...">
                </dx-select-box>
              </div>
              <div class="half-width">
                Status
                <dx-select-box formControlName="status" [dataSource]="statusi" displayExpr="status" valueExpr="id"
                  placeholder="Odaberite status...">
                </dx-select-box>
              </div>
            </div>

            <div class="form-row">
              <div class="half-width">
                Djelatnost
                <dx-select-box formControlName="djelatnost" [dataSource]="djelatnosti" displayExpr="djelatnost"
                  valueExpr="id" placeholder="Odaberite djelatnost...">
                </dx-select-box>
              </div>
              <div class="half-width">
                Domaća
                <dx-select-box formControlName="domaca" [dataSource]="domacaOptions" displayExpr="text"
                  valueExpr="value" placeholder="Domaća firma?">
                </dx-select-box>
              </div>
            </div>

            <div class="form-row">
              <div class="half-width">
                Telefon 1
                <dx-text-box formControlName="telefon1" placeholder="Telefon 1">
                </dx-text-box>
              </div>
              <div class="half-width">
                Telefon 2
                <dx-text-box formControlName="telefon2" placeholder="Telefon 2">
                </dx-text-box>
              </div>
            </div>

            <div class="form-row">
              <div class="half-width">
                Fax
                <dx-text-box formControlName="fax" placeholder="Faks">
                </dx-text-box>
              </div>
              <div class="half-width">
                Mobilni
                <dx-text-box formControlName="mobilni" placeholder="Mobilni">
                </dx-text-box>
              </div>
            </div>

            <div class="form-row">
              <div class="half-width">
                Mobilni SMS
                <dx-text-box formControlName="mobilni_sms" placeholder="Mobilni SMS">
                </dx-text-box>
              </div>
              <div class="half-width">
                Email
                <dx-text-box formControlName="email" placeholder="Email" [isValid]="!firmaForm.get('email')?.errors"
                  validationMessage="Unesite validan email">
                </dx-text-box>
              </div>
            </div>

            <div class="form-row">
              <div class="half-width">
                Direktor
                <dx-text-box formControlName="direktor" placeholder="Direktor">
                </dx-text-box>
              </div>
              <div class="half-width">
                Kontakt 1
                <dx-text-box formControlName="kontakt1" placeholder="Kontakt 1">
                </dx-text-box>
              </div>
            </div>

            <div class="form-row">
              <div class="half-width">
                Kontakt 2
                <dx-text-box formControlName="kontakt2" placeholder="Kontakt 2">
                </dx-text-box>
              </div>
              <div class="half-width">
                Web
                <dx-text-box formControlName="web" placeholder="Web stranica">
                </dx-text-box>
              </div>
            </div>

            <div class="form-row">
              <div class="half-width">
                Grad
                <dx-select-box formControlName="grad" [dataSource]="gradovi" displayExpr="grad1" valueExpr="id"
                  placeholder="Odaberite grad..." [searchEnabled]="true">
                </dx-select-box>
              </div>
              <div class="half-width">
                Država
                <dx-select-box formControlName="drzava" [dataSource]="drzave" displayExpr="naziv" valueExpr="id"
                  placeholder="Odaberite državu..." [searchEnabled]="true">
                </dx-select-box>
              </div>
            </div>

            <div class="form-row">
              <div class="half-width">
                Adresa
                <dx-text-box formControlName="adresa" placeholder="Adresa">
                </dx-text-box>
              </div>
              <div class="half-width">
                Račun
                <dx-text-box formControlName="racun" placeholder="Račun">
                </dx-text-box>
              </div>
            </div>

            <div class="form-row">
              <div class="half-width">
                PDV broj
                <dx-text-box formControlName="pdv_br" placeholder="PDV broj">
                </dx-text-box>
              </div>
              <div class="half-width">
                OIB broj
                <dx-text-box formControlName="oib_br" placeholder="JIB">
                </dx-text-box>
              </div>
            </div>

            <div class="form-row">
              <div class="third-width">
                Datum kontakta
                <dx-date-box formControlName="datum_kontakta" placeholder="Datum kontakta" displayFormat="dd.MM.yyyy">
                </dx-date-box>
              </div>
              <div class="third-width">
                Period od
                <dx-date-box formControlName="period_od" placeholder="Period od" displayFormat="dd.MM.yyyy">
                </dx-date-box>
              </div>
              <div class="third-width">
                Period do
                <dx-date-box formControlName="period_do" placeholder="Period do" displayFormat="dd.MM.yyyy">
                </dx-date-box>
              </div>
            </div>
          </div>

          <div class="popup-buttons">
            <dx-button [text]="isCreateFirma ? 'Kreiraj' : 'Ažuriraj'" type="default"
              (onClick)="isCreateFirma ? createFirma() : updateFirma()" [disabled]="!firmaForm.valid || loading">
            </dx-button>
            <dx-button text="Otkaži" (onClick)="isFirmaPopupVisible = false">
            </dx-button>
          </div>
        </form>
      </div>

      <!-- Right Side - Komentari -->
      <div class="komentari-section" *ngIf="!isCreateFirma">
        <h3>Komentari</h3>

        <!-- Add Komentar Form -->
        <div class="komentar-form">
          <form [formGroup]="komentarForm">
            <dx-text-area formControlName="komentar1" placeholder="Unesite novi komentar..." [height]="80"
              [isValid]="!komentarForm.get('komentar1')?.errors" validationMessage="Komentar je obavezan">
            </dx-text-area>

            <div class="komentar-buttons">
              <dx-button text="Dodaj komentar" type="default" (onClick)="createKomentar()"
                [disabled]="!komentarForm.valid || komentariLoading">
              </dx-button>
            </div>
          </form>
        </div>

        <!-- Komentari List -->
        <div class="komentari-list">
          <dx-data-grid #komentariGrid id="komentariGrid" keyExpr="id" [dataSource]="komentariData" [showBorders]="true"
            [showRowLines]="true" [hoverStateEnabled]="true" [height]="300" [scrolling]="{ mode: 'virtual' }">

            <dxi-column dataField="datum" caption="Datum" [width]="100" dataType="date" format="dd.MM.yyyy">
            </dxi-column>
            <dxi-column dataField="komentar1" caption="Komentar" [minWidth]="200">
              <div *dxTemplate="let cell of 'cellTemplate'">
                <div class="komentar-text">{{ cell.value }}</div>
              </div>
            </dxi-column>
            <dxi-column dataField="idKorisnika" caption="Korisnik" [width]="100" [calculateCellValue]="getUsername">
            </dxi-column>

          </dx-data-grid>
        </div>
      </div>
    </div>
  </div>
</dx-popup>

<!-- SMS SORT POPUP -->
<dx-popup [width]="600" [height]="500" [showTitle]="true"
  [title]="'Zainteresovanost firme - ' + (selectedFirma?.naziv || '')" [(visible)]="isSmsSortPopupVisible"
  (onHiding)="onSmsSortPopupHidden()">

  <div *dxTemplate="let data of 'content'">
    <div class="sms-sort-section">
      <div class="sms-sort-toolbar">
        <dx-button icon="plus" text="Dodaj artikl" type="default" (onClick)="onAddSmsSortClick()">
        </dx-button>

        <dx-button icon="trash" text="Obriši" type="danger" [disabled]="!selectedSmsSort"
          (onClick)="onDeleteSmsSortClick()">
        </dx-button>
      </div>

      <!-- SMS Sort Form -->
      <div class="sms-sort-form">
        <form [formGroup]="smsSortForm">
          <dx-select-box formControlName="artikl" [dataSource]="artikli" displayExpr="artikl1" valueExpr="id"
            placeholder="Odaberite artikl..." [isValid]="!smsSortForm.get('artikl')?.errors"
            validationMessage="Artikl je obavezan">
          </dx-select-box>

          <div class="sms-sort-buttons">
            <dx-button text="Dodaj" type="default" (onClick)="createSmsSort()"
              [disabled]="!smsSortForm.valid || smsSortLoading">
            </dx-button>

            <dx-button text="Poništi" (onClick)="selectedSmsSort = null; smsSortForm.reset()" *ngIf="selectedSmsSort">
            </dx-button>
          </div>
        </form>
      </div>

      <!-- SMS Sort Grid -->
      <dx-data-grid #smsSortGrid id="smsSortGrid" keyExpr="id" [dataSource]="smsSortData" [showBorders]="true"
        [showRowLines]="true" [hoverStateEnabled]="true" [paging]="{ pageSize: 20 }" [selection]="{ mode: 'single' }"
        (onRowClick)="onSmsSortRowClick($event)">

        <dxi-column dataField="id" caption="ID" [width]="80"></dxi-column>
        <dxi-column dataField="artikl" caption="Artikl" [minWidth]="300" [calculateCellValue]="getArtiklName">
        </dxi-column>

        <dxo-scrolling mode="virtual"></dxo-scrolling>
      </dx-data-grid>
    </div>
  </div>
</dx-popup>

<!-- LOAD PANELS -->
<dx-load-panel [position]="loadPanelPosition" [visible]="loading" [showIndicator]="true" [showPane]="true"
  [shading]="true" shadingColor="rgba(0, 0, 0, 0.4)">
</dx-load-panel>

<dx-load-panel [position]="komentariLoadPanelPosition" [visible]="komentariLoading" [showIndicator]="true"
  [showPane]="true" [shading]="true" shadingColor="rgba(0, 0, 0, 0.4)">
</dx-load-panel>

<dx-load-panel [position]="smsSortLoadPanelPosition" [visible]="smsSortLoading" [showIndicator]="true" [showPane]="true"
  [shading]="true" shadingColor="rgba(0, 0, 0, 0.4)">
</dx-load-panel>